import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.location.replace('/home');
  }, [navigate]);

  return null;
};
export default NotFound;